// extracted by mini-css-extract-plugin
export default {"container":"CustomScrollBarContainer_container__PixkJ","hideNativeScrollBar":"CustomScrollBarContainer_hideNativeScrollBar__onUdk"};